import React, { useState, useEffect } from 'react';
import { Box, TextField, Paper, List, ListItem, ListItemButton, ListItemText, CircularProgress } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export default function AddressAutocomplete({ value, onChange, label = 'Adress (sökbar)', placeholder = 'Börja skriva gatuadress…', size }) {
  const [input, setInput] = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const debounceRef = React.useRef(null);

  useEffect(() => { setInput(value || ''); }, [value]);

  function handleChange(val) {
    setInput(val);
    clearTimeout(debounceRef.current);
    if (val.trim().length < 3) { setSuggestions([]); setOpen(false); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(val + ', Sverige')}&format=json&limit=6&addressdetails=1`,
          { headers: { 'Accept-Language': 'sv' } }
        );
        const data = await res.json();
        setSuggestions(data);
        setOpen(data.length > 0);
      } catch (_) {}
      finally { setLoading(false); }
    }, 350);
  }

  function pick(loc) {
    const a = loc.address || {};
    const road = a.road || a.pedestrian || '';
    const house = a.house_number || '';
    const street = [road, house].filter(Boolean).join(' ');
    const city = a.city || a.town || a.village || a.municipality || '';
    const postcode = a.postcode || '';
    onChange({ address: street, city, postcode, full: loc.display_name });
    setInput(street + (city ? ', ' + city : ''));
    setSuggestions([]);
    setOpen(false);
  }

  return (
    <Box sx={{ position: 'relative', flex: 1 }}>
      <TextField fullWidth size={size} label={label} placeholder={placeholder}
        value={input}
        onChange={e => handleChange(e.target.value)}
        onBlur={() => setTimeout(() => setOpen(false), 200)}
        InputProps={{
          endAdornment: loading
            ? <CircularProgress size={16} />
            : <LocationOnIcon sx={{ fontSize: 18, color: '#aaa' }} />,
        }}
      />
      {open && suggestions.length > 0 && (
        <Paper sx={{ position: 'absolute', zIndex: 1400, left: 0, right: 0, mt: 0.5, maxHeight: 220, overflow: 'auto', boxShadow: 4 }}>
          <List dense disablePadding>
            {suggestions.map((loc, i) => (
              <ListItem key={i} disablePadding>
                <ListItemButton onMouseDown={() => pick(loc)}>
                  <LocationOnIcon sx={{ fontSize: 14, color: '#FF6B00', mr: 1, flexShrink: 0 }} />
                  <ListItemText
                    primary={loc.display_name.split(',').slice(0, 2).join(',')}
                    secondary={loc.display_name.split(',').slice(2, 4).join(',')}
                    primaryTypographyProps={{ fontSize: '0.82rem', fontWeight: 600 }}
                    secondaryTypographyProps={{ fontSize: '0.72rem' }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
}
